import {FC, useEffect, useState} from 'react';
import styled from 'styled-components';
import {Tag} from 'antd/lib';
import {EClientsFilterValues} from '../../../utils/enums';
import {TableParams} from '../../../types';
import {isNotEmptyArray} from '../../../utils/functions';
interface IProps {
	total: number;
	tableParams: TableParams;
	setTableParams: (params: any) => void;
}
const FilterInfo: FC<IProps> = ({total, tableParams, setTableParams}) => {
	const [filterTags, setFilterTags] = useState<string[]>([]);

	useEffect(() => {
		const {filters} = tableParams;
		let updatedTags: string[] = [];
		if (filters?.isActive !== null && filters?.isActive)
			updatedTags.push(EClientsFilterValues.STATUS);
		if (filters?.sex !== null && filters?.sex) updatedTags.push(EClientsFilterValues.GENDER);
		if (filters?.templates !== null && isNotEmptyArray(filters?.templates))
			updatedTags.push(EClientsFilterValues.TEMPLATES);
		if (filters?.age !== null && isNotEmptyArray(filters?.age))
			updatedTags.push(EClientsFilterValues.AGE);
		if (filters?.fromCreateDate && filters?.toCreateDate)
			updatedTags.push(EClientsFilterValues.CREATED);
		if (filters?.fromVisitDate && filters?.toVisitDate)
			updatedTags.push(EClientsFilterValues.VISITS);

		setFilterTags(updatedTags);
	}, [tableParams]);

	const handleClose = (removedTag: string) => {
		const newTags = filterTags.filter((tag) => tag !== removedTag);
		let removed = {};
		switch (removedTag) {
			case EClientsFilterValues.STATUS:
				removed = {isActive: null};
				break;
			case EClientsFilterValues.GENDER:
				removed = {sex: null};
				break;
			case EClientsFilterValues.AGE:
				removed = {age: null};
				break;
			case EClientsFilterValues.TEMPLATES:
				removed = {templates: null};
				break;
			case EClientsFilterValues.CREATED:
				removed = {fromCreateDate: null, toCreateDate: null};
				break;
			case EClientsFilterValues.VISITS:
				removed = {fromVisitDate: null, toVisitDate: null};
				break;
			default:
				break;
		}
		setTableParams((prevState: TableParams) => {
			const newFilters = {
				...prevState.filters,
				...removed,
			};

			return {
				...prevState,
				filters: newFilters,
			};
		});
		setFilterTags(newTags);
	};

	return (
		<FilterInfoWrap>
			<>{`Найдено пользователей: ${total}`}</>
			<InfoWrap>
				{filterTags.length > 0 && <>Активные фильтры:</>}
				{filterTags.map((tag) => (
					<Tag
						key={tag}
						closable={true}
						onClose={() => handleClose(tag)}
						color='magenta'
						bordered={false}
					>
						{tag}
					</Tag>
				))}
			</InfoWrap>
		</FilterInfoWrap>
	);
};

export default FilterInfo;

const TagsWrap = styled.div``;
const FilterInfoWrap = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 30px;
`;

const InfoWrap = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: row;
	font-family: 'Inter';
	font-style: normal;
	gap: 3px;
	font-weight: 500;
	font-size: 14px;
	/* line-height: 28px; */
	& span {
		margin-right: 1px;
	}
`;
